import LintasAPIService from '../../APIServices/lintasapi';
import { showToast } from '../../Utils';
import { userTypes } from '../../Utils/constants';
import {
  ALL_SUPPLIERS, SUPPLIER_CREATED, GET_SUPPLIER_USERS, SHOW_USER_FORM,
  UPDATE_VENDOR_USER,
  GET_DASH_SUPPLIERS,
  CREATE_DASH_SUPPLIERS,
  UPDATE_DASH_SUPPLIERS,
} from '../actionTypes';
import { handleErrorLocal, loader } from './common';

const apiCall = new LintasAPIService();

export const showUserForm = (val) => (dispatch) => {
  dispatch({
    type: SHOW_USER_FORM,
    payload: val,
  })
}

export const getSuppliers = () => (dispatch) => {
  dispatch(loader(true))
  apiCall
    .getSuppliers()
    .then((response) => {
      dispatch(loader(false))
      dispatch({
        type: ALL_SUPPLIERS,
        payload: response.data,
      })
    })
    .catch((err) => {
      dispatch(loader(false))
      dispatch(handleErrorLocal(err))
    });
};

export const createSupplierUser = (supplierId, data) => (dispatch) => {
  dispatch(loader(true))
  apiCall
    .createSupplierUser({ supplierId, data })
    .then((response) => {
      dispatch(loader(false))
      showToast('success', 'User created successfully!!');
      dispatch({
        type: SUPPLIER_CREATED,
        payload: response.data,
      })
    })
    .catch((err) => {
      dispatch(loader(false))
      dispatch(handleErrorLocal(err))
    });
}

export const getSupplierUsers = (supplierId, page = 0) => (dispatch) => {
  apiCall
    .getSupplierUsers({ supplierId, page })
    .then((response) => dispatch({
      type: GET_SUPPLIER_USERS,
      payload: response.data,
    }))
    .catch((err) => {
      dispatch(handleErrorLocal(err))
    });
}

export const updateVendorUser = (data, id) => (dispatch) => {
  apiCall
    .updateVendorUser(data, id)
    .then((response) => {
      showToast('success', response.data.message);
      dispatch({
        type: UPDATE_VENDOR_USER,
        payload: response.data.data,
      })
    })
    .catch((err) => {
      dispatch(handleErrorLocal(err))
    });
}

export const getDashboardSuppliers = (page = 0, supplierId = 0) => (dispatch) => {
  const data = { page, userType: userTypes.supplier }
  if (supplierId) {
    data.dependedValue = supplierId;
  }
  apiCall
    .getDashUsers(data)
    .then((response) => dispatch({
      type: GET_DASH_SUPPLIERS,
      payload: response.data,
    }))
    .catch((err) => {
      dispatch(handleErrorLocal(err))
    });
}

export const createDashSuppliers = (data) => (dispatch) => {
  dispatch(loader(true))
  apiCall
    .createDashUser({ data })
    .then((response) => {
      dispatch(loader(false))
      showToast('success', 'User created successfully!!');
      dispatch({
        type: CREATE_DASH_SUPPLIERS,
        payload: response.data,
      })
    })
    .catch((err) => {
      dispatch(loader(false))
      dispatch(handleErrorLocal(err))
    });
}

export const updateDashSuppliers = (data, id) => (dispatch) => {
  apiCall
    .updateDashUser(data, id)
    .then((response) => {
      showToast('success', response.data.message);
      dispatch({
        type: UPDATE_DASH_SUPPLIERS,
        payload: response.data.data,
      })
    })
    .catch((err) => {
      dispatch(handleErrorLocal(err))
    });
}

export const importVendorUsers = (file) => (dispatch) => {
  dispatch(loader(true))
  apiCall
    .importVendorUsers(file)
    .then((response) => {
      dispatch(loader(false))
      showToast('success', response.data.message);
    })
    .catch((err) => {
      dispatch(loader(false))
      dispatch(handleErrorLocal(err))
    });
}
